import { SearchableListItem } from './searchable-list.model';

export const mapperFilterParentWithChildren = (items: SearchableListItem[], filter: string): SearchableListItem[] =>
    items.filter(
        (c) =>
            c.name.toLowerCase().includes(filter.toLowerCase()) ||
            c.children?.some((child) => child.name.toLowerCase().includes(filter.toLowerCase()))
    );
